export default __webpack_public_path__ + "static/media/read-receipts-icon.481eef52.svg";